import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomDateVanTotResultaat implements IBaseVraagboomResultaat {
  van: Date;
  tot: Date;

  constructor(van: Date, tot: Date) {
    this.van = van;
    this.tot = tot;
  }
}
